import {Button, Popover, Tree} from "antd";


const ProjectSearchProjectorTab = ({
                                    project,
                                    loading
                                  }) => {
  let treeData;

  const treeObject = (title, value, key) => {
    return {
      title: title + ': ' + value,
      key: key
    }
  }

  const treeObjectPopover = (title, value, pop, level) => {
    return {
      title: (<>
          <span>{title}:&nbsp;</span>
          <Popover content={pop} placement="right"><Button size="small">{value}</Button></Popover>
        </>
      ),
      key: level
    }
  }

  const treeObjectChildren = (title, children, level) => {
    return {
      key: level,
      title: title,
      children: objToTreeData(children, level)
    }
  }

  const treeObjectPwsUserSummary = (title, children, level) => {
    let td = [];
    let i = 0;
    if (children !== undefined) {
      children.forEach(o => {
        td.push(treeObjectChildren(o.UserDisplayName + ' (' + o.UserReferenceSystemId + ')', o, level + '-' + i));
        i++;
      })
    }
    return {
      key: level,
      title: title,
      children: td
    };
  }


  const objToTreeData = (structure, lvl) => {
    let i = 0, td = [], level;

    for (const key in structure) {
      level = lvl === '' ? i : lvl + '-' + i;
      let obj = structure[key];
      if (obj === undefined || obj === null || Object.keys(obj).length === 0) {
        td.push(treeObject(key, 'null', level));
      } else {
        switch (key) {
          case 'EngagementIdentity':
            td.push(treeObjectPopover(key, obj.EngagementCode, 'UID:' + obj.EngagementUid, level));
            break;
          case 'LocationIdentity':
          case 'CurrentResourceLocationIdentity':
            td.push(treeObjectPopover(key, obj.LocationName, 'UID:' + obj.LocationUid, level));
            break;
          case 'ManagerIdentity':
          case 'UserIdentity':
          case 'CreatedByUserIdentity':
            td.push(treeObjectPopover(key, obj.UserDisplayName + ' (' + obj.UserReferenceSystemId + ')', 'UID:' + obj.UserUid, level));
            break;
          case 'ResourceIdentity':
            td.push(treeObjectPopover(key, obj.ResourceDisplayName + ' (' + obj.ResourcceReferenceSystemId + ')', 'UID:' + obj.UserUid, level));
            break;
          case 'ProjectStageIdentity':
            td.push(treeObjectPopover(key, obj.ProjectStageName, 'UID:' + obj.ProjectStageUid, level));
            break;
          case 'ContractLineItemIdentity':
            td.push(treeObjectPopover(key, obj.ContractLineItemCode, 'UID:' + obj.ContractLineItemUid, level));
            break;
          case 'BookedResourcesWorkspacePermissionSetIdentity':
          case 'CcUsersWorkspacePermissionSetIdentity':
          case 'ClientWorkspacePermissionSetIdentity':
          case 'EmWorkspacePermissionSetIdentity':
          case 'LtdBookedResourcesWorkspacePermissionSetIdentity':
          case 'LtdOtherResourcesWorkspacePermissionSetIdentity':
          case 'OtherResourcesWorkspacePermissionSetIdentity':
          case 'PmWorkspacePermissionSetIdentity':
            td.push(treeObjectPopover(key, obj.PermissionSetName, 'UID:' + obj.PermissionSetUid, level));
            break;
          case 'EngagementCurrencyIdentity':
            td.push(treeObjectPopover(key, obj.CurrencyCode, 'UID:' + obj.CurrencyUid, level));
            break;
          case 'EngagementTypeIdentity':
            td.push(treeObjectPopover(key, obj.EngagementTypeName + ' [' + obj.EngagementTypeShortName + ']',
              'UID:' + obj.EngagementTypeUid, level));
            break;
          case 'ProjectIdentity':
            td.push(treeObjectPopover(key, obj.ProjectCode, 'UID:' + obj.ProjectUid, level));
            break;
          case 'StandardRateTypeIdentity':
            td.push(treeObjectPopover(key, obj.StandardRateTypeName + ' [' + obj.StandardRateTypeCode + ']',
              'UID:' + obj.StandardRateTypeUid, level));
            break;
          case 'RateCardIdentity':
            td.push(treeObjectPopover(key, obj.RateCardName + ' [' + obj.RateCardType + ']',
              'UID:' + obj.RateCardUid, level));
            break;
          case 'CurrentResourceCostCenterIdentity':
            td.push(treeObjectPopover(key, obj.CostCenterName, 'UID:' + obj.CostCenterUid, level));
            break;
          case 'CurrentResourceResourceTypeIdentity':
            td.push(treeObjectPopover(key, obj.ResourceTypeName + ' [' + obj.ResourceTypeCode + ']',
              'UID:' + obj.ResourceTypeUid, level));
            break;
          case 'CurrentResourceTitleIdentity':
            td.push(treeObjectPopover(key, obj.TitleName + ' (' + obj.DepartmentIdentity.DepartmentName + ')',
              'UID:' + obj.TitleUid + ' (' + obj.DepartmentIdentity.DepartmentUid + ')', level));
            break;
          case 'StandardTaskTypeIdentity':
            td.push(treeObjectPopover(key, obj.StandardTaskTypeName + ' [' + obj.StandardTaskTypeCode + ']',
              'UID:' + obj.StandardTaskTypeUid, level));
            break;
          case 'Client':
            td.push(treeObjectChildren(key + ': ' + obj.ClientName + ' [' + obj.ClientNumber + ']', obj, level));
            break;
          case 'EngagementManager':
          case 'Manager':
          case 'CreatedByUser':
            td.push(treeObjectChildren(key + ': ' + obj.UserDisplayName + ' (' + obj.UserReferenceSystemId + ')', obj, level));
            break;
          case 'ManagementTeamUsers':
            td.push(treeObjectPwsUserSummary(key, obj.PwsUserSummary, level));
            break;
          default:
            if (typeof obj === "object") {
              td.push({
                title: key,
                key: level,
                children: objToTreeData(obj, level)
              })
            } else {
              td.push(treeObject(key, obj, level))
            }
            break;
        }
      }
      i++;
    }
    return td
  }

  treeData = objToTreeData(project, '')

  return (<>
    <Tree
      showLine={true}
      showIcon={false}
      defaultExpandedKeys={['0-0-0']}
      treeData={treeData}
      disabled={loading}
    />
  </>);
};

export {ProjectSearchProjectorTab};